module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/_add-edit-beneficiary/add-edit-beneficiary.component.css
// module id = ./src/app/sendMoney/_add-edit-beneficiary/add-edit-beneficiary.component.css
// module chunks = main